import classNames from "classnames";
import { StatChipData } from "../../types";
import styles from "./style.module.scss";

interface StatChipProps extends StatChipData {
  className?: string;
}

/** Tinted "12 accounts" chip that sits beside the page title. */
function StatChip({ value, label, className }: StatChipProps) {
  return (
    <span className={classNames(styles.chip, className)}>
      <b className={styles.value}>{value}</b>
      {label}
    </span>
  );
}

export default StatChip;
